var map = {
	"./Duda0-min.png": 38273,
	"./Duda1-min.png": 14026,
	"./Duda2-min.png": 17902,
	"./Duda3-min.png": 92712,
	"./Duda4-min.png": 22371,
	"./GoDaddy1-min.png": 36525,
	"./GoDaddy2-min.png": 78813,
	"./GoDaddy3-min.png": 52514,
	"./GoDaddy4-min.png": 74298,
	"./GoDaddy5-min.png": 61557,
	"./GoDaddy6-min.png": 36028,
	"./GoDaddy7-min.png": 71012,
	"./GoDaddy8-min.png": 76217,
	"./GoDaddy9-min.png": 72360,
	"./Joomla0-min.png": 36571,
	"./Joomla1-min.png": 65516,
	"./Joomla2-min.png": 72818,
	"./Joomla3-min.png": 18426,
	"./Joomla4-min.png": 81456,
	"./Joomla5-min.png": 19756,
	"./Joomla6-min.png": 28599,
	"./Joomla7-min.png": 93025,
	"./Joomla8-min.png": 29834,
	"./Joomla9-min.png": 36295,
	"./Other1-min.png": 66212,
	"./Other2-min.png": 39695,
	"./Shopify0-min.png": 1508,
	"./Shopify1-min.png": 40619,
	"./Shopify2-min.png": 55926,
	"./Shopify3-min.png": 63130,
	"./Shopify4-min.png": 79044,
	"./Squarespace0-min.png": 99309,
	"./Squarespace1-min.png": 44590,
	"./Squarespace2-min.png": 80759,
	"./Squarespace3-min.png": 62321,
	"./Squarespace4-min.png": 11912,
	"./Weebly1-min.png": 11810,
	"./Weebly2-min.png": 63289,
	"./Weebly3-min.png": 88547,
	"./Weebly4-min.png": 42782,
	"./Weebly5-min.png": 33755,
	"./Weebly6-min.png": 89972,
	"./Wix0-min.png": 86777,
	"./WordPress0-min.png": 90834,
	"./WordPress1-min.png": 59617,
	"./WordPress2-min.png": 7554,
	"./WordPress3-min.png": 13505,
	"./WordPress4-min.png": 61576,
	"./WordPress5-min.png": 14205,
	"./WordPress6-min.png": 57966,
	"./WordPress7-min.png": 5640,
	"./alert-triangle.svg": 59536,
	"./appstore-icon.png": 34962,
	"./appstore-icon.svg": 19708,
	"./dealer.png": 59103,
	"./duda.png": 35277,
	"./email_artwork.svg": 83909,
	"./godaddy.png": 83612,
	"./icon-add-member.svg": 75969,
	"./icon-agency.svg": 79328,
	"./icon-android-ios.png": 47960,
	"./icon-book-appointment.svg": 50960,
	"./icon-chat-error.svg": 18912,
	"./icon-chat-widget-integration.svg": 54715,
	"./icon-code.svg": 78765,
	"./icon-facebook.svg": 41351,
	"./icon-lead-connector.svg": 80929,
	"./icon-link.svg": 21105,
	"./joomla.png": 27362,
	"./launchpad-completed-icon.svg": 63222,
	"./other3-min.png": 41116,
	"./playstore-icon.png": 70487,
	"./playstore-icon.svg": 40200,
	"./shopify.png": 3600,
	"./sms_artwork.svg": 97106,
	"./squarespace.png": 14836,
	"./stripe_logo.png": 48977,
	"./weebly-logo-2.png": 93618,
	"./weebly.svg": 50245,
	"./wix.svg": 23963,
	"./wordpress.png": 52348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61862;